import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Image from '../../shared/components/Image';
import VerbHeading from '../../shared/components/VerbHeading';
import { IMAGE_PROPS } from '../../shared/utils/ImageUtils';

const LMSCard = (props) => {
    const { className, link, title, subtitle, thumbnailImageUrl } = props;
    const imageProps = IMAGE_PROPS.collectionImageCloudinary;
    const href = link.indexOf('http://') === 0 || link.indexOf('https://') === 0 ? link : `http://${link}`;
    return (
        <div key={link} className={cns('lms-card', className)}>
            <a target={'_blank'} href={href}>
                <div className={'lms-container row'}>
                    <div className={'col-5 lms-left-display'}>
                        <Image
                            overlay={{}}
                            src={thumbnailImageUrl}
                            dimension={imageProps.dimension}
                            cloudinaryCrop={imageProps.cloudinaryCrop}
                            className={'trackCardImage'}
                        />
                    </div>
                    <div className={'col-7 lms-card-details'}>
                        <VerbHeading
                            hNumber={6}
                            className={'lms-card-heading'}
                            messageId={'LMS_CARD_HEADING'}
                            defaultMessage={'LEARNING ECOSYSTEM'}
                        />
                        <h4 className={cns('lms-card-title')}>{title}</h4>
                        <div className={'lms-card-subtitle-container'}>
                            <small className={'lms-card-subtitle'}>{subtitle}</small>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

LMSCard.propTypes = {
    className: PropTypes.string,
    link: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    thumbnailImageUrl: PropTypes.string
};

export default LMSCard;
